import React from "react";
import { motion } from "framer-motion";
import { automateSteps } from "../Data";

// Stagger container for step cards
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.1,
    },
  },
};

// Standard clean fade-up animation
const fadeUpVariants = {
  hidden: {
    opacity: 0,
    y: 25,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

const WhatsappAutomationSteps = () => {
  return (
    <section className="automation-section">
      <div className="container">

        {/* Heading Section */}
        <div className="feature-heading">

          <motion.div
            className="feature-left"
            variants={fadeUpVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <h2 className="section-heading">
              Automate your WhatsApp
              <br />
              Marketing in{" "}
              <span>
                3 easy steps.
              </span>
            </h2>
          </motion.div>

          <motion.div
            className="feature-right"
            variants={fadeUpVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <p className="section-text">
              Automate your WhatsApp Marketing in three easy
              steps to instantly connect with target users,
              drive engagement and boost sales.
            </p>
          </motion.div>

        </div>

        {/* Automation Grid */}
        <motion.div
          className="automation-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
        >
          {automateSteps.map((item, i) => (
            <motion.div
              key={i}
              className="automation-card"
              variants={fadeUpVariants}
              whileHover={{ y: -6 }}
              transition={{ duration: 0.2, ease: "easeOut" }}
            >
              <p className="card-number">
                {item.number}
              </p>

              <div className="automation-icon-wrapper">
                <img
                  src={item.icon}
                  alt={`${item.title} | Onbbits`}
                />
              </div>

              <h3 className="card-heading">
                {item.title}
              </h3>

              <p className="section-text">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default WhatsappAutomationSteps;